import "./index.scss";
import loading from "assets/loading.png";

export function FullScreenLoader() {
  return (
    <div className="loader">
      <div className="spinner">
        <img src={loading} className="w-[62px] h-auto" alt=""/>
      </div>
      <div className="text-[21px] font-[Poppins] font-semibold text-white">Loading</div>
    </div>
  );
}
